module.exports = __webpack_public_path__ + "static/media/org_designation.06da46a0.svg";